import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../../../util';
import { hashHistory } from 'react-router';
import { Toast } from 'antd-mobile/lib';
import NavigatorMain from '../../NavigatorMain';
import { getTempInfo } from '../../../common.js';
import { requestAuthentication, confirmAuthentication, addBankCard } from '../../../action/myCardsAction';
import { addCardByHqtPost, addCardByHqtOk, addCardByHqtFinish, addCardByHqtOpenFinish,htqAddCardNum } from '../../../action/myAssets/userInfoAction'


class HqtCheckCard extends Component {

  constructor(props){
    super(props);
    this.state={
      checkCard: "",
      cardVal: "获取验证码",
      checkFlag: false,
      flag: false,
      requestNo:""
    };
    this.time = '';
  }

  goCertification = () => {
    const { router, bankAccountName, mobileNo, paymentChannelId, bankAccountShowNo, bankCode, certType, certNo, openHqt, callback, isShow, fundCode } = this.props.location.state;
    const { findHqtExist, dispatch } = this.props;
    const { requestNo, checkCard, checkFlag } = this.state;
    const { tradeAccountNo } = findHqtExist;
    if(!checkFlag) {
      Toast.show("请先获取验证码", 2);
      return false;
    }
    this.setState({
      flag: true
    })
    const data = {
      authRequestNo: requestNo,
      captcha: checkCard
    }
    const errback = () => {
      this.setState({
        flag: false
      })
    }
    const callbacks = (result) => {
      const dataSec = {
        bankAccountName: bankAccountName,
        bankAccountShowNo: bankAccountShowNo,
        bankCode: bankCode,
        authRequestSNo: requestNo,
        certType: certType,
        certNo: certNo,
        trustChannelId: paymentChannelId,
        mobileNo: mobileNo,
        otsTradeAccountNo: tradeAccountNo
      }
      const dataThr = {
        bankAccountShowNo: bankAccountShowNo,
        bankCode: bankCode,
        requestNo: requestNo,
        certificateType: certType,
        certificateNo: certNo,
        paymentChannelId: paymentChannelId,
        mobileNo: mobileNo,
        name: bankAccountName
      }
      console.log(dataSec);
      console.log(dataThr)
      const callbackSec = (result) => {
        this.setState({
          flag: false
        });

        hashHistory.push({
          pathname: "/HqtSuccess",
          state: {
            router: router,
            bankAccountShowNo: bankAccountShowNo,
            openHqt: openHqt,
            callback: callback,
            isShow: isShow,
            fundCode: fundCode
          }
        })
        this.props.dispatch(htqAddCardNum(""))
      }
      if(result) {
        // if(openHqt) {
        //   dispatch(addCardByHqtOpenFinish(dataThr, callbackSec, errback));
        // }else {
          dispatch(addCardByHqtFinish(dataSec, callbackSec, errback));
        // }
      }else {
        this.setState({
          flag: false
        });
      }
    }
    dispatch(addCardByHqtOk(data, callbacks, errback));
  }

  changeCheckCard = (value) => {
    this.setState({
      checkCard :value
    })
  }

  getCheckCard = () => {
    let count = 119;
    let thisO = this;
    const { bankAccountName, certType, certNo, mobileNo, bankAccountShowNo, paymentChannelId } = this.props.location.state;
    const { dispatch } = this.props;
    const businessType = "AddCard";

    thisO.setState({
      cardVal: count + "秒后重发",
      checkFlag: true,
      flag:true
    });
    Toast.loading();
    this.time = setInterval(() => {
      count--;
      thisO.setState({
        cardVal: count + "秒后重发",
        checkFlag: true
      })
      if(count == 0) {
        clearInterval(this.time)
        thisO.setState({
          cardVal: "获取验证码",
          checkFlag: false
        })
      }
    }, 1000)
    const data = {
      name: bankAccountName,
      certNo: certNo,
      certType: certType,
      mobileNo: mobileNo,
      bankAccountShowNo: bankAccountShowNo,
      trustChannelId: paymentChannelId,
      businessType: businessType
    }
    console.log(data)
    const callback = (result) => {
      Toast.hide();
      this.setState({
        requestNo: result.requestNo,
        flag: false
      })
    }
    const errback = () => {
       Toast.hide();
      this.setState({
        flag: false
      })
    }
    dispatch(addCardByHqtPost(data, callback, errback));
  }

  componentWillUnmount() {
    clearInterval(this.time)
  }

  componentWillMount() {
    
  }
  goBack = () => {
    hashHistory.goBack();
  }
  render() {
    let  openHqt = this.props.location.state && this.props.location.state.openHqt;
    let { checkCard, checkFlag, cardVal, flag } = this.state;
    let { findHqtExist } = this.props;
    return (
      <div className="mainBox">
        <NavigatorMain>
              <div className="boxHeader">
                <div>
                  <img onClick={this.goBack} src={require("../../../img/leftArrow_header.png")} />
                </div>
                <div>
                  <span>{ openHqt ? "开通活期通" : "添加银行卡" }</span>
                </div>
                <div>
                  
                </div>
              </div>
            </NavigatorMain> 
        <div className="boxContent">
          <div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10}}>
            <span  style={{fontSize: 13, color: "#5b6370"}}>请输入您收到的短信验证码</span>
          </div>
          <div style={styles.contentList}>
            <span  style={styles.listText}>
              验证码
            </span>
            <input
            type="text"
            style={styles.textInput}
            value={checkCard}
            onChange={(event)=>{this.setState({checkCard:event.target.value})}}
            placeholder="请输入验证码"
            />
            {
              checkFlag ? <div style={styles.checkCardBox2}>
                <span  style={styles.checkCardText2}>{cardVal}</span>
              </div> :
              <div style={styles.checkCardBox} onClick={this.getCheckCard}>
                <span  style={styles.checkCardText}>获取验证码</span>
              </div>
            }
          </div>
        </div>

        <div  style = {styles.touchHighlightBtn}  delayPressIn = {0} onClick = {checkCard != "" ? ()=>{this.goCertification()} : null }>
          <div style = {Object.assign(styles.nextStepBtn, {backgroundColor: checkCard != ""? '#FE492E' : '#afb0b2'})}>
            <span  style = {{color: '#ffffff', fontSize: 15}}>下一步</span>
          </div>
        </div>
        
      </div>
    )
  }
}

export default connect(mapStateToProps)(HqtCheckCard);

const styles = {
  btnSuccess: {
    display:"-webkit-flex",
    marginTop: 15,
    height: 40,
    backgroundColor: "#FE492E",
    WebkitJustifyContent: "center",
    WebkitAlignItems: "center",
    borderRadius: 30,
    marginLeft: 13,
    marginRight: 13,
    marginBottom: 15
  },
  contentList: {
    display:"-webkit-flex",
    height: 45,
      backgroundColor: "#fff",
      paddingLeft: 13,
      paddingRight: 13,
      WebkitAlignItems: "center",
      WebkitFlexDirection: "row",
      borderBottomWidth: 1,
      borderBottomStyle:"solid",
      borderBottomColor: 'rgb(235, 238, 240)'
  },
  contentList2: {
    display:"-webkit-flex",
    height: 45,
      backgroundColor: "#fff",
      paddingLeft: 13,
      paddingRight: 13,
      WebkitAlignItems: "center",
      WebkitFlexDirection: "row"
  },
  listText: {
    color: "#5b6370",
    fontSize: 13
  },
  textInput: {
    height: 40,
    width: 200,
    fontSize: 13,
    marginLeft: 10,
    marginTop: 3,
    color: "#3a3e47"
  },
  disableBtnSuccess: {
    display:"-webkit-flex",
    marginTop: 15,
    height: 40,
    backgroundColor: "#afb0b2",
    WebkitJustifyContent: "center",
    WebkitAlignItems: "center",
    borderRadius: 30,
    marginLeft: 13,
    marginRight: 13,
    marginBottom: 15
  },
  checkCardBox: {
    display:"-webkit-flex",
    backgroundColor: "#FE492E",
    height: 30,
    width: 90,
    WebkitJustifyContent: "center",
    WebkitAlignItems: "center",
    borderRadius: 30,
    position: "absolute",
    right: 13
  },
  checkCardText: {
    color: "#fff",
    fontSize: 13
  },
  checkCardBox2: {
    display:"-webkit-flex",
    backgroundColor: "#afb0b2",
    height: 30,
    width: 100,
    WebkitJustifyContent: "center",
    WebkitAlignItems: "center",
    borderRadius: 30,
    position: "absolute",
    right: 13
  },
  checkCardText2: {
    color: "#5b6370",
    fontSize: 13
  },
  nextStepBtn: {
    display:"-webkit-flex",
    backgroundColor: '#FE492E',
    borderRadius: 20,
    height: 40,
    WebkitFlexDirection: 'row',
    WebkitAlignItems: 'center',
    WebkitJustifyContent: 'center',
  },
  touchHighlightBtn: {
    marginTop: 14,
    marginLeft: 13,
    marginRight: 13,
    borderRadius: 20,
  },
};

function mapStateToProps(state,ownProps) {
  return {
    checkNumber: state.checkNumber,
    findHqtExist:state.findHqtExist,
  }
}


// WEBPACK FOOTER //
// ./src/components/myAssets/myCard/HqtCheckCard.js